class InstagramBlockLoad extends HTMLElement {
        constructor() {
            super();
            this.querySelector('[data-load-more-block]').addEventListener('click', this.onLoadMore.bind(this))
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 3;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 2;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                let number_show = (eleHide.length > _number ? _number : eleHide.length);
                for (let i = 0; i < number_show; i++) {
                    eleHide[i].classList.remove(_class);
                    eleHide[i].classList.add('show');
                }
                (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('instagram-block-load', InstagramBlockLoad);